import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  template: 0,
};

export const templateSlice = createSlice({
  name: "template",
  initialState,
  reducers: {
    changeTemplate: (state, action) => {
      state.template = action.payload;
    },
  },
});

export const { changeTemplate } = templateSlice.actions;

export default templateSlice.reducer;
